import Test from '../views/test/Test.vue'

export default [
  {
    path: '/test',
    component: Test
  }
]